// copy-to-clipboard.directive.ts
import { Directive, ElementRef, HostListener, Input, NgZone } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Directive({
  selector: "[copyToClipboard]",
})
export class CopyToClipboardDirective {
  @Input("copyToClipboard") copyText!: string;

  constructor(
    private readonly el: ElementRef<HTMLElement>,
    private readonly toastr: ToastrService,
    private readonly zone: NgZone
  ) {}

  @HostListener("click")
  async onClick() {
    if (!this.copyText) return;

    const copied =
      (await this.copyWithClipboardApi()) || this.copyWithExecCommand();

    // La promesa nativa de clipboard no la parchea zone.js: sin zone.run el
    // toast se crea pero no se pinta hasta la siguiente detección de cambios
    this.zone.run(() => {
      if (copied) {
        this.toastr.success("Copiado al portapapeles!");
      } else {
        this.toastr.error("No se pudo copiar al portapapeles");
      }
    });
  }

  // La API solo existe en contextos seguros y puede rechazar (permisos, foco)
  private async copyWithClipboardApi(): Promise<boolean> {
    if (!navigator?.clipboard?.writeText) return false;
    try {
      await navigator.clipboard.writeText(this.copyText);
      return true;
    } catch {
      return false;
    }
  }

  // Fallback: el textarea se inserta junto al host para quedar dentro del modal
  private copyWithExecCommand(): boolean {
    const container = this.el.nativeElement.parentElement || document.body;
    const textarea = document.createElement("textarea");
    textarea.value = this.copyText;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "-9999px";
    textarea.style.opacity = "0";
    container.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      return document.execCommand("copy");
    } catch {
      return false;
    } finally {
      container.removeChild(textarea);
      this.el.nativeElement.focus();
    }
  }
}
